export function toFillFormat(text, color = 'DeepPink', fontWeight = 'normal') {
  return `<span style="color:${color};font-weight:${fontWeight};">${text}</span>`;
}

export default toFillFormat;
